/**
 * Minimal overrides for NiceAdmin-style default MUI look.
 * Ripple and focus-visible only; buttons/inputs use theme defaults.
 */
export const inputsCustomizations = {
  MuiButtonBase: {
    defaultProps: {
      disableRipple: false,
    },
    styleOverrides: {
      root: ({ theme }) => ({
        '&:focus-visible': {
          outline: `2px solid ${theme.palette.primary.main}`,
          outlineOffset: 2,
        },
      }),
    },
  },
};
